import {
  ActionIcon,
  Badge,
  Button,
  Flex,
  Grid,
  Menu,
  rem,
  Select,
  Text,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import { useDebouncedState, useDisclosure, useHotkeys } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconCaretDown,
  IconFileExport,
  IconPackage,
  IconRefresh,
  IconSearch,
  IconShieldCheck,
  IconTransform,
  IconX,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useDeferredValue, useEffect, useState } from "react";
import {
  repositoryDelivery,
  repositoryMdm,
} from "../../../_base/_const/_constVar";
import { default as _breadcrumb } from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { getValueById } from "../../../_base/helper/FunctionHelper";
import { paginationBase } from "../../../_base/model/_base/BaseTable";
import { formatDateTransfer } from "../../../common/FormatDate/FormatDate";
import { BASE_API_DELIVERY } from "../../../config";
import { _localization } from "../../../config/location";
import { MessageResponse } from "../../../model/MessageResponse";
import { getTblDmEmployeeAll } from "../../../service/getSelectApi";
import ActiveProduct from "./ActiveProduct";
import UpdateAlwaysInStock from "./UpdateAlwaysInStock";
import UpdateBhmrPackage from "./UpdateBhmrPackage";
import SyncItemTMĐT from "./SyncItemTMĐT";
type TypeCategoryCombination = {
  itemId: number;
  itemCode: string;
  itemName: string;
  maHang: string;
  tenHang: string;
  maLinhVuc: string;
  tenLinhVuc: string;
  maNganh: string;
  tenNganh: string;
  maLoai: string;
  tenLoai: string;
  maChung: string;
  tenChung: string;
  maNhom: string;
  tenNhom: string;
  maModel: string;
  tenModel: string | null;
  maHangSx: string | null;
  tenHangSx: string | null;
  active: number | null;
  attribute56: number | null;
  attribute57: number | null;
  lastActiveBy: number | null;
  lastActiveDate: string | null;
};

const CategoryCombination = ({ breadCrumb }: { breadCrumb?: any }) => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<TypeCategoryCombination[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [pagination, setPagination] = useState(paginationBase);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const rowSelectionDeferred =
    useDeferredValue<MRT_RowSelectionState>(rowSelection);
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [visible, { toggle, open, close }] = useDisclosure(false);
  const [search, setSearch] = useDebouncedState(
    {
      maHang: "",
      maLinhVuc: "",
      maNganh: "",
      maLoai: "",
      maChung: "",
      maNhom: "",
      maModel: "",
      maHangSx: "",
      keySearch: "",
      attribute56: "",
      attribute57: "",
    },
    300,
  );

  const [dataEmployee, setDataEmployee] = useState<any[]>([]);

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);

    setIsError(false);

    let url = `?Skip=${pagination?.pageIndex}&Take=${pagination.pageSize}`;

    if (search.maHang.length > 0) {
      url += `&MaHang=${search.maHang}`;
    }

    if (search.maLinhVuc.length > 0) {
      url += `&MaLinhVuc=${search.maLinhVuc}`;
    }

    if (search.maNganh.length > 0) {
      url += `&MaNganh=${search.maNganh}`;
    }

    if (search.maLoai.length > 0) {
      url += `&MaLoai${search.maLoai}`;
    }

    if (search.maChung.length > 0) {
      url += `&MaChung=${search.maChung}`;
    }

    if (search.maNhom.length > 0) {
      url += `&MaNhom=${search.maNhom}`;
    }

    if (search.maModel.length > 0) {
      url += `&MaModel=${search.maModel}`;
    }

    if (search.maHangSx.length > 0) {
      url += `&MaHangSx=${search.maHangSx}`;
    }

    if (search.keySearch.length > 0) {
      url += `&KeySearch=${search.keySearch}`;
    }

    if (search.attribute56.length > 0) {
      url += `&Attribute56=${search.attribute56}`;
    }

    if (search.attribute57) {
      url += `&Attribute57=${search.attribute57}`;
    }

    try {
      const response = await repositoryDelivery.get(
        `/api/v1/TblDmItemCategoryCombination/get-list${url}`,
      );
      if (response && response.httpStatusCode === 200) {
        let result = response.data;
        setIsLoading(false);
        setData(result);
        setRowCount(response.totalCount);
        table.resetRowSelection();
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsRefetching(false);
    }
  };

  const exportDataExcel = async () => {
    let url = `?Skip=${pagination?.pageIndex}&Take=${pagination.pageSize}`;

    if (search.maHang.length > 0) {
      url += `&MaHang=${search.maHang}`;
    }

    if (search.maLinhVuc.length > 0) {
      url += `&MaLinhVuc=${search.maLinhVuc}`;
    }

    if (search.maNganh.length > 0) {
      url += `&MaNganh=${search.maNganh}`;
    }

    if (search.maLoai.length > 0) {
      url += `&MaLoai${search.maLoai}`;
    }

    if (search.maChung.length > 0) {
      url += `&MaChung=${search.maChung}`;
    }

    if (search.maNhom.length > 0) {
      url += `&MaNhom=${search.maNhom}`;
    }

    if (search.maModel.length > 0) {
      url += `&MaModel=${search.maModel}`;
    }

    if (search.maHangSx.length > 0) {
      url += `&MaHangSx=${search.maHangSx}`;
    }

    if (search.keySearch.length > 0) {
      url += `&KeySearch=${search.keySearch}`;
    }

    if (search.attribute56.length > 0) {
      url += `&Attribute56=${search.attribute56}`;
    }

    // const baseUrl = `https://apis-pos-dev.hacom.vn/api-shipping/api/v1/ExportExcel/export-item-category${url}`;
    // const fileName = "danh_muc_vat_tu.xlsx";

    // await exportDataToExcel(baseUrl, fileName);
    const baseUrl = `/api/v1/ExportExcel/export-item-category${url}`;

    const _url = BASE_API_DELIVERY + baseUrl;
    const token = localStorage.getItem("token");

    const response = await fetch(_url, {
      method: "GET",
      headers: {
        "Content-Type": "application/vnd.ms-excel",
        Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to download file");
    }
    const blob = await response.blob();
    const urlss = window.URL.createObjectURL(blob);
    const _name = new Date().toISOString().slice(0, 10);
    let filename = "danh_muc_vat_tu.xlsx";
    const link = document.createElement("a");
    link.href = urlss;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };

  const handleSyncAllInDmVt = async () => {
    open();
    try {
      const res = await repositoryMdm.post<MessageResponse<any>>(
        "/api/v1/SyncDataFromAsia/sync-all-in-dm-vt",
      );

      if (res && res.success) {
        NotificationExtension.Success("Hoàn tất đồng bộ danh mục vật tư !");
        setTimeout(() => {
          fetchData();
        }, 1000);
      } else {
        NotificationExtension.Fails(res?.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  const handleSyncAllInDmVtNhom = async () => {
    open();
    try {
      const res = await repositoryMdm.post<MessageResponse<any>>(
        "/api/v1/SyncDataFromAsia/sync-all-in-dm-vt-nhom",
      );

      if (res && res.success) {
        NotificationExtension.Success(
          "Hoàn tất đồng bộ danh mục nhóm vật tư !",
        );
        setTimeout(() => {
          fetchData();
        }, 1000);
      } else {
        NotificationExtension.Fails(res?.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  const handleSyncAllInDmVtPl = async () => {
    open();
    try {
      const res = await repositoryMdm.post<MessageResponse<any>>(
        "/api/v1/SyncDataFromAsia/sync-all-in-dm-vt-pl",
      );

      if (res && res.success) {
        NotificationExtension.Success(
          "Hoàn tất đồng bộ danh mục phân loại vật tư !",
        );
        setTimeout(() => {
          fetchData();
        }, 1000);
      } else {
        NotificationExtension.Fails(res?.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  const handleChangeSearchValue = (value: string, key: string) => {
    if (value !== "Invalid date")
      setSearch((prevData) => ({ ...prevData, [key]: value }));
    else {
      setSearch((prevData) => ({ ...prevData, [key]: "" }));
    }
  };

  const modalsSyncItem = () => {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Đồng bộ sản phẩm TMĐT</Title>
        </>
      ),
      size: "700px",
      children: <SyncItemTMĐT />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const fetchDataEmp = async () => {
    const res = await getTblDmEmployeeAll();

    if (res) {
      const data = res
        .filter((item) => item.id && item.fullname)
        .map((item) => ({
          label: `${item.code} - ${item.fullname}`,
          value: String(item.id),
        }));
      setDataEmployee(data);
    }
  };

  const modalsActiveProduct = (ids: string[]) => {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Đổi trạng thái sản phẩm</Title>
        </>
      ),
      size: "auto",
      children: <ActiveProduct ids={ids} onSuccess={fetchData} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const modalsUpdateAlwaysInStock = (ids: string[]) => {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Luôn luôn có tồn ít nhất là 1</Title>
        </>
      ),
      size: "auto",
      children: <UpdateAlwaysInStock ids={ids} onSuccess={fetchData} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const modalsUpdateBhmrPackage = (ids: string[]) => {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Gói bảo hành mở rộng (BHMR)</Title>
        </>
      ),
      size: "auto",
      children: <UpdateBhmrPackage ids={ids} onSuccess={fetchData} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const columns = React.useMemo<MRT_ColumnDef<TypeCategoryCombination>[]>(
    () => [
      {
        accessorKey: "itemCode",
        header: "Mã Sản Phẩm",
        Cell: ({ renderedCellValue }) => (
          <>
            <Badge variant="dot" color="green" radius="xs">
              {renderedCellValue}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "itemName",
        header: "Tên Sản Phẩm",
        size: 750,
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "maHang",
        header: "Mã Hàng",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "tenHang",
        header: "Tên Hàng",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "maLinhVuc",
        header: "Mã Lĩnh Vực",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "tenLinhVuc",
        header: "Tên Lĩnh Vực",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "maNganh",
        header: "Mã Ngành",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "tenNganh",
        header: "Tên Ngành",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "maLoai",
        header: "Mã Loại",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "tenLoai",
        header: "Tên Loại",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "maChung",
        header: "Mã Chung",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "tenChung",
        header: "Tên Chung",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "maNhom",
        header: "Mã Nhóm",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "tenNhom",
        header: "Tên Nhóm",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "maModel",
        header: "Mã Model",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "tenModel",
        header: "Tên Model",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "pl1",
        header: "Phân loại 1",
      },
      {
        accessorKey: "partNumber",
        header: "Phân loại 2",
      },
      {
        accessorKey: "pl3",
        header: "Phân loại 3",
      },
      {
        accessorKey: "pl4",
        header: "Phân loại 4",
      },
      {
        accessorKey: "pl5",
        header: "Phân loại 5",
      },
      {
        accessorKey: "pl6",
        header: "Phân loại 6",
      },
      {
        accessorKey: "maHangSx",
        header: "Mã Hãng Sản Xuất",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "tenHangSx",
        header: "Tên Hãng Sản Xuất",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "warranty",
        header: "Hạn BH",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {renderedCellValue} tháng
          </Text>
        ),
      },
      {
        accessorKey: "warrantyVendor",
        header: "Hạn BH NCC",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {renderedCellValue} tháng
          </Text>
        ),
      },
      {
        accessorKey: "thoiGianBhKhac",
        header: "Thời gian BH Khác",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {renderedCellValue}
          </Text>
        ),
      },
      {
        accessorKey: "active",
        header: "Trạng thái",
        Cell: ({ renderedCellValue }) => (
          <Text size="12.5px" fw={500}>
            {renderedCellValue === 1 ? (
              <Badge color="green">Sử dụng</Badge>
            ) : renderedCellValue === 0 ? (
              <Badge color="red">Không sử dụng</Badge>
            ) : (
              <Badge color="gray">Không xác định</Badge>
            )}
          </Text>
        ),
      },
      {
        accessorKey: "attribute56",
        header: "Luôn có tồn ít nhất 1",
        size: 175,
        Cell: ({ renderedCellValue }) => (
          <Text size="12.5px" fw={500}>
            {Number(renderedCellValue) === 1 ? (
              <Badge color="teal">Có</Badge>
            ) : (
              <Badge color="gray">Không</Badge>
            )}
          </Text>
        ),
      },
      {
        accessorKey: "attribute57",
        header: "Gói BHMR",
        size: 120,
        Cell: ({ renderedCellValue }) => (
          <Text size="12.5px" fw={500}>
            {Number(renderedCellValue) === 1 ? (
              <Badge color="violet">Có</Badge>
            ) : (
              <Badge color="gray">Không</Badge>
            )}
          </Text>
        ),
      },
      {
        accessorKey: "lastActiveBy",
        header: "Người cập nhật trạng thái cuối cùng",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {getValueById(String(renderedCellValue), dataEmployee, "label")}
          </Text>
        ),
        size: 275,
      },
      {
        accessorKey: "lastActiveDate",
        header: "Ngày cập nhật trạng thái cuối cùng",
        size: 275,
        Cell: ({ renderedCellValue }) => (
          <Text size="12.5px" fw={"500"}>
            {renderedCellValue &&
              formatDateTransfer(String(renderedCellValue || "") || "")}
          </Text>
        ),
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableSorting: false,
        enableColumnFilter: false,
        size: 150,
        Cell: ({ row }) => (
          <Flex gap={"xs"}>
            <Tooltip label="Đổi trạng thái">
              <ActionIcon
                variant="light"
                color="blue"
                onClick={() => {
                  modalsActiveProduct([String(row.original.itemId)]);
                }}
              >
                <IconTransform size={18} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Luôn có tồn ít nhất 1">
              <ActionIcon
                variant="light"
                color="teal"
                onClick={() => {
                  modalsUpdateAlwaysInStock([String(row.original.itemId)]);
                }}
              >
                <IconPackage size={18} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Gói BHMR">
              <ActionIcon
                variant="light"
                color="violet"
                onClick={() => {
                  modalsUpdateBhmrPackage([String(row.original.itemId)]);
                }}
              >
                <IconShieldCheck size={18} />
              </ActionIcon>
            </Tooltip>
          </Flex>
        ),
      },
    ],
    [pagination?.pageSize, pagination?.pageIndex, dataEmployee],
  );

  const table = useMantineReactTable({
    columns,
    data: data || [],
    positionToolbarAlertBanner: "bottom",
    enableColumnResizing: true,
    enableRowNumbers: true,
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    getRowId: (row) => row.itemId?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-select", "mrt-row-numbers", "itemCode"],
        right: ["action"],
      },
      columnVisibility: { id: true },
      density: "xs",
    },
    enableRowSelection: true,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: true,
    rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontSize: "12.5px",
        padding: "5px 12px",
        fontWeight: 500,
      },
    }),
    state: {
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
  });

  useHotkeys([
    [
      "Enter",
      () => {
        fetchData();
      },
    ],
  ]);

  useEffect(() => {
    fetchDataEmp();
  }, []);

  useEffect(() => {
    fetchData();
  }, [pagination]);

  useEffect(() => {
    //   startTransition(() => {
    const valuesList = Object.keys(rowSelectionDeferred);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelectionDeferred);
      setSelectIds(valuesList);
    }
    //  });
  }, [rowSelectionDeferred]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 190 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (235 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, [height]);

  return (
    <>
      <div
        style={{
          padding: "0px 10px",
          overflowX: "hidden",
        }}
      >
        <Flex justify={"space-between"} align={"center"}>
          <_breadcrumb></_breadcrumb>
          <Flex gap={"xs"}>
            <Button
              leftSection={
                <IconTransform style={{ width: rem(14), height: rem(14) }} />
              }
              onClick={() => modalsActiveProduct(selectIds)}
            >
              Đổi trạng thái sản phẩm
            </Button>
            <Button
              leftSection={
                <IconPackage style={{ width: rem(14), height: rem(14) }} />
              }
              onClick={() => modalsUpdateAlwaysInStock(selectIds)}
            >
              Luôn có tồn
            </Button>
            <Button
              leftSection={
                <IconShieldCheck style={{ width: rem(14), height: rem(14) }} />
              }
              onClick={() => modalsUpdateBhmrPackage(selectIds)}
            >
              Gói BHMR
            </Button>
            <Button
              leftSection={
                <IconRefresh style={{ width: rem(14), height: rem(14) }} />
              }
              onClick={() => modalsSyncItem()}
            >
              Đồng bộ vật tư TMĐT
            </Button>
            <Menu shadow="md" width={200}>
              <Menu.Target>
                <Button
                  // size="xs"
                  rightSection={
                    <IconCaretDown
                      style={{ width: rem(14), height: rem(14) }}
                    />
                  }
                >
                  Chức năng
                </Button>
              </Menu.Target>

              <Menu.Dropdown>
                <Menu.Label>Application</Menu.Label>
                <Menu.Item
                  leftSection={
                    <IconFileExport
                      style={{ width: rem(14), height: rem(14) }}
                    />
                  }
                  onClick={() => exportDataExcel()}
                >
                  Export Excel
                </Menu.Item>
                <Menu.Item
                  leftSection={
                    <IconX style={{ width: rem(14), height: rem(14) }} />
                  }
                >
                  Đóng
                </Menu.Item>
              </Menu.Dropdown>
            </Menu>
          </Flex>
        </Flex>
      </div>
      <Grid mt={5}>
        <Grid.Col span={{ base: 12, md: 6, lg: 2.4 }}>
          <TextInput
            w={"100%"}
            placeholder="Từ khoá"
            type="text"
            leftSection={<IconSearch color="#15aabf" />}
            defaultValue={search.keySearch}
            onChange={(e) =>
              handleChangeSearchValue(e.currentTarget.value, "keySearch")
            }
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6, lg: 2.4 }}>
          <Select
            w={"100%"}
            placeholder="Luôn có tồn ít nhất 1"
            clearable
            data={[
              { label: "Có", value: "true" },
              { label: "Không", value: "false" },
            ]}
            defaultValue={search.attribute56}
            onChange={(value) =>
              handleChangeSearchValue(value ?? "", "attribute56")
            }
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6, lg: 2.4 }}>
          <Select
            w={"100%"}
            placeholder="Gói BHMR"
            clearable
            data={[
              { label: "Có", value: "true" },
              { label: "Không", value: "false" },
            ]}
            defaultValue={search.attribute57}
            onChange={(value) =>
              handleChangeSearchValue(value ?? "", "attribute57")
            }
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6, lg: 2.4 }}>
          <Button
            onClick={() => fetchData()}
            leftSection={<IconSearch size={14} />}
            color="blue"
            variant="outline"
          >
            Tìm kiếm
          </Button>
        </Grid.Col>
      </Grid>

      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </>
  );
};

export default CategoryCombination;
